import {
  CREATE_NEW_REVIEW_SUCCESS,
  CREATE_NEW_REVIEW_FAIL,
} from '../constants/reviews.constant';

import { changeNotificationInfo } from './general.action';

import { ReviewService } from '../../services/allApiServices';

const ReviewFactory = new ReviewService();

const createReview = (reviewData, token) => async (dispatch) => {
  const { data } = await ReviewFactory.createOne(reviewData, token);
  if (data.status === 'success') {
    dispatch({
      type: CREATE_NEW_REVIEW_SUCCESS,
      payload: data,
    });
    dispatch(
      changeNotificationInfo({
        status: 'open',
        type: 'success',
        message: `Đăng đánh giá thành công!`,
      })
    );
  } else {
    dispatch(
      changeNotificationInfo({
        status: 'open',
        type: 'error',
        message: `Có lỗi xảy ra!`,
      })
    );
  }
};

export { createReview };
